import React from 'react'

const PageSection: React.FC = ({ children }) => (
	<div className="page-section">
		{children}
	</div>
)


export default PageSection